var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcedures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2187_42697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.25,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.25,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint0_radial_2187_42697)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.07031,
    y: 6.25,
    width: 29.208,
    height: 29.208,
    rx: 14.604,
    fill: "url(#paint1_radial_2187_42697)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.37488,
    y: 5.55457,
    width: 30.5989,
    height: 30.5989,
    rx: 15.2994,
    stroke: "white",
    strokeWidth: 1.39086
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_42697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9306 25.0778C26.9306 22.1442 26.9306 19.2105 26.9306 16.2769C26.9306 15.8098 26.7214 15.3476 26.376 15.0314C26.0695 14.7444 25.6511 14.5789 25.2327 14.5789C23.3548 14.5789 21.4818 14.5789 19.6039 14.5789C19.132 14.5644 18.6552 14.7444 18.3292 15.0801C18.013 15.3914 17.8281 15.8341 17.8281 16.2769C17.8281 16.6418 17.8281 17.0115 17.8281 17.3764C18.2076 17.3764 18.5871 17.3764 18.9665 17.3764C18.9665 17.0115 18.9665 16.6418 18.9665 16.2769C18.9665 16.0531 19.1125 15.839 19.3217 15.7612C19.4433 15.7077 19.5795 15.7222 19.7109 15.7222C21.4964 15.7222 23.2818 15.7222 25.0722 15.7222C25.184 15.7222 25.3057 15.7125 25.4127 15.7563C25.5927 15.8195 25.7338 15.9752 25.7776 16.1601C25.797 16.2428 25.7922 16.3304 25.7922 16.4131C25.7922 19.41 25.7922 22.4069 25.7922 25.3989C25.797 25.7006 25.5246 25.9584 25.223 25.9633C25.223 26.3428 25.223 26.7222 25.223 27.0969C25.5441 27.092 25.8652 27.0044 26.1327 26.8341C26.5317 26.5812 26.8187 26.1628 26.9014 25.6957C26.9403 25.4914 26.9257 25.2822 26.9306 25.0778Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.711 18.2764V17.3764H25.0723V18.2764H19.711Z",
    fill: "#516CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1025 19.5891C23.796 19.2972 23.3776 19.1317 22.9592 19.1317C21.8938 19.1317 20.8283 19.1317 19.7629 19.1317C19.4369 18.8058 19.1158 18.4798 18.7899 18.1539C18.6731 18.0371 18.5077 17.9836 18.3472 17.9933C17.6709 17.9933 16.9947 17.9933 16.3184 17.9933C16.1773 17.9933 16.0314 17.9884 15.8903 18.0079C15.506 18.0566 15.146 18.2414 14.8784 18.5187C14.5816 18.8301 14.4065 19.2582 14.4065 19.6912C14.4065 21.5838 14.4065 23.4763 14.4065 25.3688C14.4016 25.6607 14.4746 25.9575 14.6205 26.2153C14.9124 26.7456 15.4962 27.1008 16.1044 27.0959C18.3082 27.0959 20.5121 27.0959 22.7208 27.0959C22.8911 27.0959 23.0614 27.1008 23.2316 27.0716C23.6598 27.0035 24.0538 26.7554 24.3117 26.4051C24.5306 26.118 24.6474 25.758 24.6474 25.398C24.6474 23.8801 24.6474 22.3622 24.6474 20.8394C24.6474 20.3675 24.443 19.9053 24.1025 19.5891ZM20.0937 23.6806C20.0937 24.0601 20.0937 24.4396 20.0937 24.819C19.7142 24.819 19.3348 24.819 18.9553 24.819C18.9553 24.4396 18.9553 24.0601 18.9553 23.6806C18.5758 23.6806 18.1963 23.6806 17.8169 23.6806C17.8169 23.3011 17.8169 22.9217 17.8169 22.5422C18.1963 22.5422 18.5758 22.5422 18.9553 22.5422C18.9553 22.1627 18.9553 21.7832 18.9553 21.4037C19.3348 21.4037 19.7142 21.4037 20.0937 21.4037C20.0937 21.7832 20.0937 22.1627 20.0937 22.5422C20.4732 22.5422 20.8526 22.5422 21.2321 22.5422C21.2321 22.9217 21.2321 23.3011 21.2321 23.6806C20.8526 23.6806 20.4732 23.6806 20.0937 23.6806Z",
    fill: "#516CD3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2187_42697",
    x: 0.507115,
    y: 0.686802,
    width: 40.3373,
    height: 40.3373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08629
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2187_42697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2187_42697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2187_42697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.778 12.335) rotate(51.0441) scale(24.5185 24.5185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2187_42697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2772 31.807) rotate(-93.6705) scale(24.9998 27.8633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_42697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5177,
    height: 12.5179,
    fill: "white",
    transform: "translate(14.4141 14.5938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedures);
export default __webpack_public_path__ + "static/media/Procedures.b7073f1662eca4ecb7b30dfb4c26f8a6.svg";
export { ForwardRef as ReactComponent };